module.exports = __webpack_public_path__ + "static/img/Parkenda_VerticalLogo_FullColour.d6b7064.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_design/Parkenda_VerticalLogo_FullColour.png
// module id = 46
// module chunks = 1